// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__NCn-K","insightsList":"newBusinessInsightsMenu_insightsList__22R1O","active":"newBusinessInsightsMenu_active__3TYMB"};